document.querySelectorAll('.fg-jt').forEach(function (root) {
  var mobileLimit = Number(root.getAttribute('data-mobile-limit'));
  if (!mobileLimit || mobileLimit < 1) {
    mobileLimit = 2;
  }

  var items = root.querySelectorAll('.fg-jt__item');

  items.forEach(function (item, index) {
    if (index >= mobileLimit) {
      item.setAttribute('data-mobile-hidden', 'true');
    } else {
      item.removeAttribute('data-mobile-hidden');
    }
  });
});
